import { Rarity } from "@dcl/schemas";
import styled from "@emotion/styled";
import { Link as LinkMui } from "@mui/material";
const Link = styled(LinkMui)((props) => {
    return {
        color: `${Rarity.getColor(props.rarity)}`,
        textDecorationColor: "transparent",
    };
});
export { Link };
//# sourceMappingURL=NotificationItemNFTLink.styled.js.map